import type { Style } from "@bezpart-board/shared";
import { LINE_DASH_PRESETS, LINE_STROKE_PRESETS, LINE_WIDTH_PRESETS } from "../../editor/lineSession";
import { PEN_DASH_PRESETS } from "../../editor/penSession";
import type { StrokeStylePartial } from "../../editor/style/applyStylePatch";

type Props = {
  disabled?: boolean;
  stroke: string;
  strokeWidth: number;
  strokeDash?: Style["strokeDash"];
  /** Include wavy dash (line/arrow). */
  includeWavy?: boolean;
  strokePresets?: readonly string[];
  widthPresets?: readonly number[];
  onChange: (partial: StrokeStylePartial) => void;
};

export function StrokeStylePicker({
  disabled = false,
  stroke,
  strokeWidth,
  strokeDash = "solid",
  includeWavy = false,
  strokePresets = LINE_STROKE_PRESETS,
  widthPresets = LINE_WIDTH_PRESETS,
  onChange,
}: Props) {
  const dashPresets = includeWavy ? LINE_DASH_PRESETS : PEN_DASH_PRESETS;

  return (
    <>
      <div className="wb-selection-toolbar__section">
        <span className="wb-selection-toolbar__label">Цвет</span>
        <div className="wb-selection-toolbar__swatches">
          {strokePresets.map((c) => (
            <button
              key={c}
              type="button"
              className={`wb-selection-toolbar__swatch${stroke === c ? " is-active" : ""}`}
              style={{
                background: c,
                boxShadow: c === "#ffffff" ? "inset 0 0 0 1px #cbd5e1" : undefined,
              }}
              title={c}
              disabled={disabled}
              aria-pressed={stroke === c}
              onClick={() => onChange({ stroke: c })}
            />
          ))}
        </div>
      </div>
      <div className="wb-selection-toolbar__section">
        <span className="wb-selection-toolbar__label">Штрих</span>
        <div className="wb-pen-options__dashes wb-selection-toolbar__dashes">
          {dashPresets.map((d) => (
            <button
              key={d.id}
              type="button"
              className={`wb-pen-options__dash${strokeDash === d.id ? " is-active" : ""}`}
              title={d.title}
              disabled={disabled}
              aria-pressed={strokeDash === d.id}
              onClick={() => onChange({ strokeDash: d.id as Style["strokeDash"] })}
            >
              {d.label}
            </button>
          ))}
        </div>
      </div>
      <div className="wb-selection-toolbar__section">
        <span className="wb-selection-toolbar__label">Толщина</span>
        <div className="wb-selection-toolbar__widths">
          {widthPresets.map((w) => (
            <button
              key={w}
              type="button"
              className={`wb-selection-toolbar__width-btn${strokeWidth === w ? " is-active" : ""}`}
              title={`${w}px`}
              disabled={disabled}
              aria-pressed={strokeWidth === w}
              onClick={() => onChange({ strokeWidth: w })}
            >
              {w}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
